import React, { FC } from 'react';

import { Meta } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Meta/Meta';
import { subtitlesPosition } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Subtitles/Subtitles.types';
import { MetaMode } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Meta/Meta.types';

import { useSubtitlesSettings } from '../../feature-player/hooks/skin/use-subtitles';

interface MoviePlayerMetaProps {
    title: string;
    logoUrl: string | undefined;
    logoWidth: number | undefined;
    logoHeight: number | undefined;
    subtitle?: string;
    className?: string;
    editorAnnotation?: string;
    mode?: MetaMode;
}

export const MoviePlayerMeta: FC<MoviePlayerMetaProps> = ({
    title,
    subtitle,
    logoUrl,
    logoWidth,
    logoHeight,
    className,
    editorAnnotation,
    mode = MetaMode.DEFAULT,
}) => {
    const { position: subtitlePosition, isActive: isSubtitlesActive } = useSubtitlesSettings();

    if (isSubtitlesActive && subtitlePosition === subtitlesPosition.TOP) {
        return null;
    }

    return (
        <Meta
            title={title}
            logoUrl={logoUrl}
            logoWidth={logoWidth}
            logoHeight={logoHeight}
            subTitle={subtitle}
            className={className}
            editorAnnotation={editorAnnotation}
            mode={mode}
        />
    );
};
